import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const solutions = [{
    title: 'Analgésicos y Pastillas',
    desc: 'Solo tapan el dolor temporalmente mientras destruyen tu estómago y riñones a largo plazo.'
  }, {
    title: 'Reposo Total',
    desc: 'Hace que la rodilla vuelva más rígida, oxidada, y mucho más difícil de mover al levantarte.'
  }, {
    title: 'Caminatas Largas',
    desc: 'Sin la preparación adecuada, solo causan más roce, desgaste e inflamación en el cartílago.'
  }, {
    title: 'Rodilleras Elásticas',
    desc: '"Apagan" tus músculos naturales, haciendo que tu articulación sea cada vez más débil y dependiente.'
  }];
  return <section className="py-20 bg-[#E8F0EC]" data-id="element-19">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-20">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-22">
            Por Qué Lo Que Intentaste No Funcionó
          </h2>
          <p className="text-xl text-gray-700" data-id="element-23">
            No es tu culpa. El sistema médico tradicional suele enfocarse en
            "parches" en lugar de solucionar la raíz del problema.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-24">
          {solutions.map((item, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 flex gap-6 items-start hover:shadow-md transition-shadow" data-id="element-25">
              <div className="flex-shrink-0 mt-1" data-id="element-26">
                <XCircle className="w-8 h-8 text-red-500" data-id="element-27" />
              </div>
              <div data-id="element-28">
                <h3 className="text-2xl font-bold text-[#1B5E5E] mb-3" data-id="element-29">
                  {item.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-30">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}